import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import { TFunction } from 'i18next';

import { constructFullName } from '@utils/constructFullName';
import { getPhysicalLocation } from '@utils/getPhysicalLocation';

import {
  ConferenceAddress,
  FetchConferenceQuery,
  FormattedLocation,
  MeetingType,
  PresidentialRepresentativeType,
} from './types';

export const getPresRepFullName = (
  presRep?: PresidentialRepresentativeType | null
): string | null | undefined =>
  pipe(presRep, O.fromNullable, O.mapNullable(constructFullName), O.toNullable);

export const getConferenceLocation = (
  t: TFunction,
  venueType: MeetingType,
  conferenceAddress?: ConferenceAddress | FormattedLocation | null
) =>
  venueType === MeetingType.Online
    ? t('global.meetingtype.online', 'Online Only')
    : getPhysicalLocation(conferenceAddress);

export const mapConferenceToConferenceSummary = (
  t: TFunction,
  conferenceData: FetchConferenceQuery | null | undefined
) => {
  return pipe(
    O.fromNullable(conferenceData),
    O.map(
      ({
        startDate,
        endDate,
        presidentialRepresentative: presRep,
        conferenceAddress,
        venueType,
        districtId,
      }) => ({
        location: getConferenceLocation(t, venueType, conferenceAddress),
        presidentialRepresentative: getPresRepFullName(
          presRep as PresidentialRepresentativeType
        ),
        districtId,
        startDate,
        endDate,
      })
    ),
    O.toNullable
  );
};
